import React from "react";
import Summary from "../../../../components/cases/assets/balanceOfAssets/securities/Summary";

const Securities = ({ next, back, tabText }) => {
  return (
    <>
      <Summary next={next} back={back} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="Securities"
        setVisited={visited}
      /> */}
    </>
  );
};

export default Securities;
